var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"hy-switch",class:[_vm.switchType==true?'hy-switch-atvice':''],style:(_vm.switchStyle),on:{"click":function($event){return _vm.hySwitch()}}})}
var staticRenderFns = []

export { render, staticRenderFns }